import { Badge } from "@/components/ui/badge";
import { ListChecks, Check } from "lucide-react";
import ProofBadge from "@/components/ProofBadge";

export default function TodaysActionsCard({
  actions, planId, checked, proofsMap, onToggle, onProofChange
}) {
  if (!actions?.length) return null;
  const doneCount = actions.filter((_, i) => {
    const pr = proofsMap[String(i)];
    return !!checked[`ta_${i}`] || (pr && !pr.is_deleted);
  }).length;
  const progressPct = actions.length ? Math.round((doneCount / actions.length) * 100) : 0;

  return (
    <div data-testid="todays-actions" className="lg:col-span-2 bg-white border border-zinc-200 rounded-2xl p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-500">
          <ListChecks className="h-4 w-4 text-emerald-600" /> Today's actions · execute now
        </div>
        <div className="text-xs text-zinc-500">{doneCount}/{actions.length} done · {progressPct}%</div>
      </div>
      <div className="mt-3 h-1.5 bg-zinc-100 rounded-full overflow-hidden">
        <div className="h-full bg-emerald-500 progress-line" style={{ width: `${progressPct}%` }} />
      </div>
      <ul className="mt-5 space-y-2">
        {actions.map((a, i) => {
          const key = `ta_${i}`;
          const proof = proofsMap[String(i)];
          const hasProof = proof && !proof.is_deleted;
          const isDone = !!checked[key] || hasProof;
          return (
            <li
              key={`action-${i}-${(a.task || "").slice(0, 24)}`}
              data-testid={`action-item-${i}`}
              className={`flex items-start gap-3 p-3 rounded-xl border ${
                isDone ? "border-emerald-200 bg-emerald-50/50"
                       : "border-zinc-200 bg-zinc-50/50 hover:border-zinc-300"
              }`}
            >
              <button
                onClick={() => onToggle(key)}
                data-testid={`action-toggle-${i}`}
                className={`h-5 w-5 rounded-md border-2 shrink-0 mt-0.5 flex items-center justify-center transition-colors ${
                  isDone ? "bg-emerald-500 border-emerald-500" : "border-zinc-300 hover:border-indigo-500"
                }`}
                aria-label="toggle action"
              >
                {isDone && <Check className="h-3 w-3 text-white" />}
              </button>
              <div className="flex-1 min-w-0">
                <div className={`text-sm font-medium ${isDone ? "line-through text-zinc-500" : "text-zinc-900"}`}>{a.task}</div>
                <div className="flex flex-wrap items-center gap-2 mt-1 text-xs text-zinc-500">
                  <Badge variant="outline" className="text-[10px]">{a.category}</Badge>
                  <span>⏱ {a.time_minutes} min</span>
                  {a.priority === "high" && <Badge className="bg-rose-500 text-[10px]">High priority</Badge>}
                  <span className="hidden md:inline">— {a.why}</span>
                </div>
              </div>
              <ProofBadge
                planId={planId}
                actionIndex={i}
                proof={proof}
                onChange={(next) => onProofChange(i, next, checked[key])}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
